import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { apiOg } from './client';
const PATH = '/api/v1/admin/event-settings';
export const eventSettingsQueryKey = ['og', 'event-settings'];
export function useEventSettings(enabled = true) {
    return useQuery({
        queryKey: eventSettingsQueryKey,
        queryFn: () => apiOg('users', PATH),
        enabled,
        retry: false,
    });
}
export function useUpdateEventSettings() {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: (body) => apiOg('users', PATH, { method: 'PUT', body }),
        onMutate: () => queryClient.cancelQueries({ queryKey: eventSettingsQueryKey }),
        onSuccess: (saved) => queryClient.setQueryData(eventSettingsQueryKey, saved),
    });
}
